export const buildSanitizedAddress = (address) => {
  if (!address) {
    return null;
  }

  return {
    ...address,
    fullName: address.name,
    addressLine1: address.line1,
    addressLine2: address.line2,
    cityLocality: address.city,
    stateProvince: address.state,
    company: address.company || address.name,
  };
};

export const deepTrim = (currentObject, keysToIgnore) => {
  if (!currentObject || Array.isArray(currentObject)) {
    return currentObject;
  }

  if (typeof currentObject === 'string') {
    return currentObject.trim();
  }

  if (typeof currentObject === 'object') {
    return Object.keys(currentObject).reduce((acc, key) => {
      if (keysToIgnore?.includes(key)) {
        return {
          ...acc,
          [key]: currentObject[key],
        };
      }

      return {
        ...acc,
        [key]: deepTrim(currentObject[key], keysToIgnore),
      };
    }, {});
  }

  return currentObject;
};
